module.exports = __webpack_public_path__ + "img/gray-down-arrow.f8310988.svg";